(function () {
  const GA_ID = "G-QQ9MCFT9PY";

  window.dataLayer = window.dataLayer || [];

  function gtag() {
    window.dataLayer.push(arguments);
  }

  if (!window.gtag) {
    window.gtag = gtag;
    if (!document.querySelector(`script[src*="${GA_ID}"]`)) {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(script);
    }
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false });
  }

  function clean(value, maxLength) {
    return String(value || "").trim().slice(0, maxLength || 120);
  }

  function send(eventName, params) {
    const payload = Object.assign(
      {
        event_category: "genkidama",
        page_path: window.location.pathname,
      },
      params || {}
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));

    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, payload);
    }
  }

  window.GenkiAnalytics = {
    send,
    search(term, count, status) {
      send("genki_search", {
        search_term: clean(term),
        result_count: Number(count || 0),
        status_filter: clean(status || "all", 40),
      });
    },
    searchNoResults(term) {
      send("genki_search_no_results", {
        search_term: clean(term),
      });
    },
    searchClick(term, productTitle, productUrl, status) {
      send("genki_search_click", {
        search_term: clean(term),
        item_name: clean(productTitle, 160),
        item_url: clean(productUrl, 240),
        item_status: clean(status, 40),
      });
    },
    searchSuggestion(input, suggestion) {
      send("genki_search_suggestion", {
        search_term: clean(input),
        suggested_term: clean(suggestion),
      });
    },
    searchStatus(term, status) {
      send("genki_search_status_filter", {
        search_term: clean(term),
        status: clean(status, 40),
      });
    },
    filterUsed(filter, value, active) {
      send("genki_filter_used", {
        filter_name: clean(filter, 80),
        filter_value: clean(value, 120),
        active: Boolean(active),
      });
    },
    filterPrice(min, max) {
      send("genki_filter_price", {
        price_min: clean(min, 30),
        price_max: clean(max, 30),
      });
    },
    filterSort(value) {
      send("genki_filter_sort", {
        sort_value: clean(value, 80),
      });
    },
    addToCart(id, title, variantId, quantity) {
      send("genki_add_to_cart", {
        item_id: clean(id, 80),
        item_name: clean(title, 160),
        variant_id: clean(variantId, 80),
        quantity: Number(quantity || 1),
      });
    },
  };
})();
